import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('admin_tool_run', '/admin_tool_runs')
const actions = generator.generate()

export default actions
